import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.ChooseSchedule = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    if (Job.Data.backToSubmit === true){
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
    }
    else {
      onStepProgression()
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    $('.choose-schedule').addClass('hidden')
    $('#job-modal').data('bootstrapValidator').removeField('schedule').removeField('scheduleDate')

    if (Job.Data.quoteEstimate !== null) {
      if (Job.Data.canCall === true && Job.Data.quoteEstimate >= 12) { // Job::QuotesEstimator::SUPPRESSANT_MINIMUM_QUOTES
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.GetContactPreference)
      }
      else {
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.AddAttachment)
      }
    }
    else {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.AddAttachment)
    }
  },

  component: React.createClass({
    getInitialState: function() {
      const job = Job.Data;

      return {
        schedule:     job.schedule,
        scheduleDate: job.scheduleDate
      }
    },

    componentDidMount: function() {
      $('#job-modal').bootstrapValidator({ /* */ })
      this.validator = $('#job-modal').data('bootstrapValidator')

      $('#schedule-radio-group').radioButtonGroup({activeRowClass: 'active'})

      $('#schedule-date').datepicker({
        container: '#job-modal',
        format: 'dd/mm/yyyy',
        disableTouchKeyboard: true,
        todayHighlight: true,
        orientation: 'top left',
        startDate: '+1d'
      }).on('changeDate', function(event) {
        $(this).datepicker('hide')
        $('#job-modal').data('bootstrapValidator').$form.data('bootstrapValidator').revalidateField("scheduleDate") //revalidating removes error message
        Job.Actions.updateScheduleDate(event.currentTarget.value)
      })

      this.setupValidation()
    },

    setupValidation: function() {
      const validator = this.validator;

      $(function() { // doc ready
        validator.addField(
          'schedule',
          {
            validators: {
              notEmpty: {
                message: 'Please select a schedule for when you want the job done'
              }
            }
          }
        )
        validator.addField(
          'scheduleDate',
          {
            validators: {
              notEmpty: {
                message: 'Please select a date for when you want the job done'
              }
            }
          }
        )
      }) // end doc ready
    },

    autoProgress: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]
      Job.Actions.updateSchedule($selectedItem.value)
      hideScheduleDatePanel()

      if (Job.Data.backToSubmit === true){
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
      }
      else {
        this.props.onStepProgression()
      }

      function hideScheduleDatePanel() {
        $('#schedule-panel').addClass('fade hidden')
      }
    },

    handleDateClick: function(e) {
      Job.Actions.updateSchedule("on_a_particular_date")
      Job.Actions.updateScheduleDate($('#schedule-date').val())
    },

    handleScheduleRadioClick: function() {
      this.validator.$form.data('bootstrapValidator').revalidateField("schedule") //revalidating removes error message
    },

    render: function() {
      const radioButtonVisible = "col-xs-2 col-sm-2 circle"
      let radioButtonHidden = `${radioButtonVisible} hidden`

      return (
        <div>
          <div className="form-group choose-schedule" onClick={this.handleScheduleRadioClick}>
            <h3 className="mb15 mt10">When do you need the job done?</h3>
            <div className="radio-button-box minor-bold" id="schedule-radio-group">
              <div className="radio" onClick={this.autoProgress}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10 this-week">I’m flexible</div>
                  <input type="radio" id="flexible" name="schedule" value="flexible" className="form-control invisible"/>
                </div>
              </div>
              <div className="radio" onClick={this.autoProgress}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">In the next few weeks</div>
                  <input type="radio" id="next_couple_of_weeks" name="schedule" value="next_couple_of_weeks" className="form-control invisible"/>
                </div>
              </div>
              <div className="radio" onClick={this.autoProgress}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10 asap-urgent">Urgently</div>
                  <input type="radio" id="asap_urgent" name="schedule" value="asap_urgent" className="form-control invisible"/>
                </div>
              </div>
              <div className="radio" href="#schedule-panel" role="tab" data-toggle="tab" onClick={this.handleDateClick} >
                <div className="row">
                  <div className='col-xs-10 col-sm-10'>On a Particular Date</div>
                  <input type="radio" name="schedule" value="on_a_particular_date" className="form-control invisible" />
                </div>
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="schedule-panel" className="tab-pane form-group" role="tabpanel" >
              <h3 className="mb15 mt30">Best date for work</h3>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon bg-white"><i className="ficon-calendar"></i></div>
                  <input id="schedule-date" name="scheduleDate" ref="schedule-date" type="textbox" className="form-control" placeholder="What Day?" defaultValue={this.state.scheduleDate} />
                </div>
                <span className="pull-right pt10">
                  <JobWizardMobile.NavigationButtons
                    navButtonLayout='okButton'
                    onStepProgression={this.props.onStepProgression}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
